import React from "react";
import { connect } from "react-redux";
import { Formik, Form } from "formik";
import { useNavigate } from "react-router";
import { Row, Col } from "react-bootstrap";

import { SIDEBAR_BUTTONS } from "../../constants";
import { isSpinnerEnabled } from "../../shared/utility";
import LogoImage from "../../assets/images/LoginLogo.png";
import { authenticationActions } from "../../redux/actions";
import Button from "../../shared/components/Buttons/Button";
import { EmailIcon, PasswordIcon } from "../../assets/icons/iconsProvider";
import InputTextField from "../../shared/components/inputTextField/InputTextField";
import { loginValidationSchema } from "../../shared/validationSchema/validationSchema";
import InputPasswordField from "../../shared/components/inputPasswordField/InputPasswordField";
import { getMacAddress } from "../../shared/Printers/ReceiptPrinters/printReceipt";
import {
  authenticationConstants,
  buttonNameConstants,
  buttonTypeConstants,
  routesPathConstants,
  systemConstants,
  NO_MAC_ADDRESS_FOUND,
} from "../../constants";

//-------Login component start here
const Login = (props) => {
  const initialValues = {
    email: "",
    password: "",
  };
  const navigate = useNavigate();
  //-------Handle login click
  const handleLogin = async (values) => {
    props.handleLoginClick(
      {
        email: values.email.toLowerCase(),
        password: values.password,
      },
      (await getMacAddress()) || NO_MAC_ADDRESS_FOUND
    );
    props.setActiveSidebarBtn(SIDEBAR_BUTTONS.INVENTORY);
  };

  const handleForgotPasswordClick = () => {
    navigate(routesPathConstants.FORGOT_PASSWORD);
  };

  //-------Return Login Component
  return (
    <div>
      <div className="login-card-wrapper row m-0  min-vh-100 min-vw-100 d-flex">
        {/* LEFT SIDE */}
        <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-center text-white left-login-side">
          <img
            className="login-loot-ledger-icon"
            src={LogoImage}
            alt="lootledger icon"
          />
          <div className="text-center">
            <h1 className="m-0">LootLedger</h1>
            <p className="fs-5 mt-4">
              Streamlined Inventory & Collection Tracking
            </p>
          </div>
        </div>

        {/* RIGHT SIDE (LOGIN CARD) */}
        <div className="col-12 col-md-6 d-flex justify-content-center align-items-center">
          <div className="login-card col-sm-10 col-md-10 col-lg-8 py-4 px-5 pb-3 d-flex flex-column justify-content-center align-items-center rounded-4">
            <h1 className="py-2">Login</h1>

            <Formik
              initialValues={initialValues}
              validate={loginValidationSchema}
              onSubmit={handleLogin}
            >
              <Form className="login-form-wrapper w-100">
                <Row className="w-100 m-0">
                  <Col xs={12} className="p-0 mb-3">
                    <InputTextField
                      type="email"
                      name="email"
                      label="Email"
                      placeHolder="Email Address"
                    />
                  </Col>

                  <Col xs={12} className="p-0 mb-3">
                    <InputPasswordField
                      type="password"
                      name="password"
                      label="Password"
                      placeHolder="Password"
                      autoComplete="on"
                    />
                  </Col>

                  <Col xs={12} className="p-0 mt-3">
                    <Button
                      type="submit"
                      className="w-100"
                      label={buttonNameConstants.LOGIN}
                      buttonType={buttonTypeConstants.BLACK_BUTTON}
                      isDisabled={isSpinnerEnabled(
                        props.spinnerArray,
                        authenticationConstants.EMPLOYEE_LOGIN
                      )}
                    />
                  </Col>

                  <Col
                    xs={12}
                    className="p-0 mt-4 mb-0 d-flex justify-content-center align-items-center"
                  >
                    Powered by LootLedger
                  </Col>
                </Row>
              </Form>
            </Formik>
          </div>
        </div>
      </div>
    </div>

    // <div>
    //   <div className=" login-card-wrapper row d-flex justify-content-center align-items-center m-0 p-4 min-vh-100 min-vw-100">
    //     <img
    //       className="login-loot-ledger-icon"
    //       src={LogoImage}
    //       alt="lootledger icon"
    //     />
    //     <div className="login-card col-sm-8 col-md-6 col-lg-4 py-4 px-5 pb-3 d-flex mt-4 flex-column justify-content-center align-items-center rounded-4">
    //       <h1 className="py-2">Login</h1>
    //       <Formik
    //         initialValues={initialValues}
    //         validate={loginValidationSchema}
    //         onSubmit={handleLogin}
    //       >
    //         <Form className="login-form-wrapper">
    //           <Row className="w-100 m-0">
    //             <Col xs={12} className="p-0 mb-3">
    //               <InputTextField
    //                 type="email"
    //                 name="email"
    //                 label="Email"
    //                 placeHolder="Email Address"
    //               />
    //             </Col>
    //             <Col xs={12} className="p-0 mb-3">
    //               <InputPasswordField
    //                 type="password"
    //                 name="password"
    //                 label="Password"
    //                 placeHolder="Password"
    //                 autoComplete="on"
    //               />
    //             </Col>
    //             <Col xs={12} className="p-0 mt-3 ">
    //               <Button
    //                 type="submit"
    //                 className="w-100"
    //                 label={buttonNameConstants.LOGIN}
    //                 buttonType={buttonTypeConstants.BLACK_BUTTON}
    //                 isDisabled={isSpinnerEnabled(
    //                   props.spinnerArray,
    //                   authenticationConstants.EMPLOYEE_LOGIN
    //                 )}
    //               />
    //             </Col>
    //             <Col
    //               xs={12}
    //               className="p-0 mt-4 mb-0 d-flex justify-content-center align-items-center text-muted text-white"
    //             >
    //               Powered by LootLedger
    //             </Col>
    //           </Row>
    //         </Form>
    //       </Formik>
    //     </div>
    //   </div>
    // </div>
  );
}; //-------Login component end here

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  spinnerArray: state.system.spinnerArray,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  handleLoginClick: (data, macAdress) =>
    dispatch(authenticationActions.companyLogin(data, macAdress)),
  setActiveSidebarBtn: (data) =>
    dispatch({ type: systemConstants.SET_ACTIVE_SIDEBAR_BTN, data: data }),
});

//-------Export Login Component
export default connect(mapStateToProps, mapDispatchToProps)(Login);
